import { useContextualMenu } from '@databases/contextual-menu';
import usePanel from '@databases/panel/usePanel';
import usePanelState from '@databases/panel/usePanelState';
import { useKeyboardShortcut } from '@databases/react';
import { getService } from '@databases/service-container';
import { removeTextSelection } from '@databases/utils/database/utils';
import { useViewUiState } from '@databases/views/useViewUiState';

import { CLOSE_SHORTCUT } from '../shortcuts';

const useCloseViewPanelKeyboardShortcut = () => {
  const { hidePanel } = usePanel();
  const { isPanelVisible } = usePanelState();
  const { setActivePanelSetting } = useViewUiState();
  const selectionsActions = getService('SelectionsActions');
  const { closeMenu } = useContextualMenu();

  useKeyboardShortcut(
    CLOSE_SHORTCUT,
    () => {
      if (isPanelVisible()) {
        // when we remove the view settings panel from the panel stack (i.e. the
        // top/visible panel is the view settings panel), we want to clear its settings
        if (isPanelVisible('ViewSettingsPanel')) {
          setActivePanelSetting(null);
        }

        hidePanel();
        selectionsActions.clearSelectionIntent();
      } else {
        removeTextSelection();
        selectionsActions.deselectAll();
        closeMenu();
      }
    },
    false
  );
};

export default useCloseViewPanelKeyboardShortcut;
